// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInstrumentDto } from './IInstrumentDto';
import {
    IInstrumentDtoFromJSON,
    IInstrumentDtoFromJSONTyped,
    IInstrumentDtoToJSON,
    IInstrumentDtoToJSONTyped,
} from './IInstrumentDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageInstrumentDto
 */
export interface IPageInstrumentDto {
    /**
     * 
     * @type {number}
     * @memberof IPageInstrumentDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageInstrumentDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageInstrumentDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IInstrumentDto>}
     * @memberof IPageInstrumentDto
     */
    content?: Array<IInstrumentDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageInstrumentDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageInstrumentDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageInstrumentDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageInstrumentDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageInstrumentDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageInstrumentDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageInstrumentDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageInstrumentDto interface.
 */
export function instanceOfIPageInstrumentDto(value: object): value is IPageInstrumentDto {
    return true;
}

export function IPageInstrumentDtoFromJSON(json: any): IPageInstrumentDto {
    return IPageInstrumentDtoFromJSONTyped(json, false);
}

export function IPageInstrumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageInstrumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IInstrumentDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageInstrumentDtoToJSON(json: any): IPageInstrumentDto {
    return IPageInstrumentDtoToJSONTyped(json, false);
}

export function IPageInstrumentDtoToJSONTyped(value?: IPageInstrumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IInstrumentDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

